export { default as KpiCompliancePanel } from "./KpiCompliancePanel.vue";
